import { Badge } from '@shopify/polaris';
import { useTranslation } from 'react-i18next';
import type { Severity } from '../lib/types.js';

const TONE: Record<Severity, 'critical' | 'warning' | 'info'> = {
  critical: 'critical',
  warning: 'warning',
  info: 'info',
};

export function SeverityBadge({ severity }: { severity: Severity }): JSX.Element {
  const { t } = useTranslation();
  return <Badge tone={TONE[severity]}>{t(`severity.${severity}`)}</Badge>;
}
